import type * as z from "zod";
import { searchInputOf, searchResultOf } from "../search";

// What reference finds (ADR-117): the records of the datasets with a code, as one type. A hit's `parentId` is the key
// of its dataset, where it opens. The type needs the permission of the administration's list.

export const referenceSearchTypes = ["reference_record"] as const;
export type ReferenceSearchType = (typeof referenceSearchTypes)[number];

export const referenceSearchPermissions = {
  reference_record: "reference.read",
} as const satisfies Record<ReferenceSearchType, string>;

export const searchReferenceInput = searchInputOf(referenceSearchTypes);
export type SearchReferenceInput = z.input<typeof searchReferenceInput>;

export const referenceSearchDto = searchResultOf(referenceSearchTypes).meta({ id: "ReferenceSearch" });
export type ReferenceSearch = z.output<typeof referenceSearchDto>;
